export default __webpack_public_path__ + "locales/sl/Webhooks.json?hash=cb9ce45325c5d5959a07de13b5936985";